export default {
  'Difficulty level': 'Zorluk seviyesi',
  'Your bet': 'Bahis',
  'Start game': 'Oyna',
  'Take prize': 'Al',
  'Try again': 'Tekrar deneyin',
  Bet: 'Bahis',
  Profit: 'Kar',
};
